import React from "react";
import { indigo } from "@material-ui/core/colors";
import IconButton from '@material-ui/core/IconButton';

export default function Icon({ icon, color, action, size="medium", style={}, disabled=false }) {

    const styleButton = { background: indigo[500], color: color, width: "40px", height: "40px", ...style }
    styleButton.background = disabled ? indigo[50] : indigo[500];

    return (
        <IconButton size={size} disabled={disabled} aria-label="close" style={styleButton} onClick={action}>
            {icon}
        </IconButton>
    );
}
